/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Firebase token exchange payload.
 * @export
 * @interface AuthenticateWithFirebaseRequest
 */
export interface AuthenticateWithFirebaseRequest {
    /**
     * Firebase ID token to validate
     * @type {string}
     * @memberof AuthenticateWithFirebaseRequest
     */
    idToken: string;
}

/**
 * Check if a given object implements the AuthenticateWithFirebaseRequest interface.
 */
export function instanceOfAuthenticateWithFirebaseRequest(value: object): value is AuthenticateWithFirebaseRequest {
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    return true;
}

export function AuthenticateWithFirebaseRequestFromJSON(json: any): AuthenticateWithFirebaseRequest {
    return AuthenticateWithFirebaseRequestFromJSONTyped(json, false);
}

export function AuthenticateWithFirebaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticateWithFirebaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idToken': json['idToken'],
    };
}

export function AuthenticateWithFirebaseRequestToJSON(json: any): AuthenticateWithFirebaseRequest {
    return AuthenticateWithFirebaseRequestToJSONTyped(json, false);
}

export function AuthenticateWithFirebaseRequestToJSONTyped(value?: AuthenticateWithFirebaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idToken': value['idToken'],
    };
}

